// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GuaranteeBlock__root--CTQT {
    display: flex;
    flex-direction: column;
    border: 4px solid var(--obscure-color);
    padding: 24px;
    text-align: center;
    border-radius: 12px;
}

.GuaranteeBlock__title--dUU3 {
    font-size: 18px;
    font-weight: 700;
    line-height: 28px;
    color: var(--secondary-color);
    margin-bottom: 24px;
}

.GuaranteeBlock__description--NLvN {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: var(--secondary-color);
}

.GuaranteeBlock__description--NLvN > a {
        text-decoration: underline;
    }

.GuaranteeBlock__guaranteeImage--o47J {
    width: 67px;
    height: auto;
    aspect-ratio: 1.33 / 1.2;
    margin: 0 auto;
    margin-bottom: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/GuaranteeBlock/GuaranteeBlock.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,sCAAsC;IACtC,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AAKjC;;AAHI;QACI,0BAA0B;IAC9B;;AAGJ;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,cAAc;IACd,mBAAmB;AACvB","sourcesContent":[".root {\n    display: flex;\n    flex-direction: column;\n    border: 4px solid var(--obscure-color);\n    padding: 24px;\n    text-align: center;\n    border-radius: 12px;\n}\n\n.title {\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 28px;\n    color: var(--secondary-color);\n    margin-bottom: 24px;\n}\n\n.description {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n    color: var(--secondary-color);\n\n    > a {\n        text-decoration: underline;\n    }\n}\n\n.guaranteeImage {\n    width: 67px;\n    height: auto;\n    aspect-ratio: 1.33 / 1.2;\n    margin: 0 auto;\n    margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `GuaranteeBlock__root--CTQT`,
	"title": `GuaranteeBlock__title--dUU3`,
	"description": `GuaranteeBlock__description--NLvN`,
	"guaranteeImage": `GuaranteeBlock__guaranteeImage--o47J`
};
export default ___CSS_LOADER_EXPORT___;
